module.exports = __webpack_public_path__ + "img/stump-plus.c60dd56f.svg";